import React, { useState, useEffect } from "react";
import axios from "axios";
import { Chart as ChartJS, Legend } from 'chart.js/auto'
import { Line } from 'react-chartjs-2'
import { Doughnut } from 'react-chartjs-2';
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";

import '../Dashboard.css';
import classes from "./Home.module.css";
import styles from '../Dashboard.module.css';

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";


function Home() {
  const [views, setViews] = useState([]);
  ReactSession.setStoreType("localStorage");
  const logged_user = ReactSession.get('logged_user');

  useEffect(() => {
    axios.post(`${process.env.REACT_APP_API_URL}/api/mediaviews.php`, {
      user_id: logged_user,
    }, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    }).then(res => {
      // console.log(res.data);
      setViews(res.data);
    })
  }, [])

  const data1 = {
    labels: ['Videos', 'Musics', 'Images'],
    datasets: [
      {
        label: '# of Votes',
        data: [views.videos, views.musics, views.images],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };
  
  const data2 = {
    labels: ["Videos", "Musics", "Images", "Groups", "WebLinks"],
    datasets: [
      // {
      //   label: "First dataset",
      //   data: [33, 53, 85, 41, 44, 65],
      //   fill: true,
      //   backgroundColor: "rgba(75,192,192,0.2)",
      //   borderColor: "rgba(75,192,192,1)",
      //   lineTension: 0.5 
      // },
      {
        label: "Views",
        data: [views.videos, views.musics, views.images, views.groups, views.weblinks],
        fill: false,
        // borderColor: "#742774",
        borderColor: "red",
        lineTension: 0.3,
        padding: '40'
      }
    ],
    options: {
      layout: {
          padding: 20
      }
    }

  };

  const option1 = {
    plugins: {
      title: {
          display: true,
          align: 'center',
          text: 'Your views',
          padding: 20,
      },
      legend: {
          display: true,
          position: 'bottom',
          labels: {
            padding: 20
          }
      }  
    }
  }

  const option2 = {
    plugins: {
      title: {
          display: true,
          align: 'center',
          text: 'Views graph',
          padding: 20
      },
      legend: {
          display: false,
          position: 'chartArea',
          labels: {
            padding: 20
          }
      }  
    }
  }

  return (
    <>
      <Helmet>
          <title>Dashboard</title>
        </Helmet>
      <div className="container_wrapper">
        <Header />
        <div className={`${styles.main} main`}>
          <Sidebar active="dashboard" />
          <div className={styles.main_content}>
            <div className={styles.content_body}>
              <div className={classes.charts}>
                <div className="row">
                  <div className="col-md-4">
                    <div className={` ${styles.card}`}>
                      <div className="card-body pt-0">
                        <div className={classes.doughnut_chart}>
                          <div className={classes.chart}>
                            <Doughnut
                              data={data1}
                              options={option1}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className={styles.card}>
                      <div className="card-body pt-0">
                        <Line
                          data={data2}
                          options={option2}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;